// Landing Page Color Palette
export const palette = {
    primary: {
        light: '#5A8BE6',
        main: '#3772DB', // Blue: RGB 55, 114, 219
        dark: '#2A5AAF',
        contrastText: '#fff',
    },
    secondary: {
        light: '#FFB84D', // Lighter orange
        main: '#DC9100', // Orange: RGB 220, 145, 0
        dark: '#B37800', // Darker orange
        contrastText: '#fff',
    },
    success: {
        light: '#7DB877',
        main: '#508647', // Green: RGB 80, 134, 71
        dark: '#3D6636',
        contrastText: '#fff',
    },
    warning: {
        light: '#FFF3CA',
        main: '#FEC604', // Golden yellow
        dark: '#C99C01',
        contrastText: '#343A40',
    },
    error: {
        light: '#EF5350',
        main: '#D32F2F', // Standard MUI error red
        dark: '#C62828',
        contrastText: '#fff',
    },
    text: {
        primary: '#253344', // Dark navy blue
        secondary: '#4A5568',
        tertiary: '#718096',
        hint: '#EEF2F6',
    },
    background: {
        paper: '#fff',
        default: '#fbfbfb',
        warm: '#fafafa',
    },
    border: '#DEE2E6',
};
